import { Component, computed, effect, input, ViewChildren } from '@angular/core';
import { CustomFieldCollectionDetailDto, CustomFieldCollectionInstanceDetailDto } from '@artemis-software/wr-api';
import { CustomFormComponent } from '@shared/custom-form/custom-form/custom-form.component';

@Component({
  selector: 'wr-custom-field-collections',
  standalone: false,
  templateUrl: './custom-field-collections.component.html',
  styleUrl: './custom-field-collections.component.scss',
})
export class CustomFieldCollectionsComponent {
  customFieldCollections = input.required<CustomFieldCollectionDetailDto[]>();
  instances = input.required<CustomFieldCollectionInstanceDetailDto[] | undefined>();

  readonly customFieldCollectionsAndValues = computed(() => {
    const collections = this.customFieldCollections();
    const instances = this.instances() ?? [];
    return collections.map(c => ({
      collection: c,
      instance: instances.find(i => i.collection.id === c.id),
    }));
  });

  private expandedCollections = new Set<string>();

  formReadonly = input.required<boolean>();

  @ViewChildren(CustomFormComponent)
  customForms!: CustomFormComponent[];

  constructor() {
    effect(() => {
      const collections = this.customFieldCollections();
      this.expandedCollections.clear();

      for (const c of collections) {
        this.expandedCollections.add(c.id);
      }
    });
  }

  isCollectionExpanded(id: string): boolean {
    return this.expandedCollections.has(id);
  }

  toggleCollection(id: string): void {
    if (this.expandedCollections.has(id)) {
      this.expandedCollections.delete(id);
    } else {
      this.expandedCollections.add(id);
    }
  }
}
